// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"7ff18d1b","513":"3a73bdc5","787":"7699acdd"}[chunkId] + ".chunk.js";
};